import React from "react";
import { Button, useMediaQuery, useTheme } from "@mui/material";

const PrimaryButton = ({ children, ...props }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery("(min-width: 600px) and (max-width: 900px)");
  
  return (
    <Button
      type="submit"
      variant="contained"
      fullWidth
      style={{
                backgroundColor: "#F04951",
                color: "#FFFFFF",
                borderRadius: "10px",
                boxShadow: "0px 6px 0px #141414", // Increased from 4px to 6px for thicker shadow
                height: isMobile ? "36px" : "44px",
                width: isMobile ? "100%" : "100%",
                fontFamily: "Red Hat Display, sans-serif",
                fontWeight: 700,
                fontSize: isMobile ? "12px" : "14px",
                lineHeight: isMobile ? "11px" : "14px",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: isMobile ? "4px" : "8px",
                textTransform: "none",
                transition: "all 0.3s ease",
                cursor: "pointer",
                border: "none", // Add this to remove default button border
              }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;